const LANGUAGE_FADE_OUT_MS = 170;
const LANGUAGE_FADE_IN_DELAY_MS = 90;

let isLanguageTransitionInProgress = false;

const wait = (ms) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });

const ensureLanguageBundle = async (lng, i18n) => {
  if (lng === "en" && !i18n.hasResourceBundle("en", "translation")) {
    const en = await import("../locales/en.json");
    i18n.addResourceBundle("en", "translation", en.default || en);
  }
};

const restoreScrollPosition = (scrollY) => {
  window.scrollTo({ top: scrollY, left: 0, behavior: "instant" });
  requestAnimationFrame(() => {
    window.scrollTo({ top: scrollY, left: 0, behavior: "instant" });
  });
};

export const getLocalizedPath = ({ pathname, search = "", hash = "" }, lng) => {
  const basePath = pathname.replace(/^\/en(?=\/|$)/, "") || "/";

  if (lng === "en") {
    return `/en${basePath === "/" ? "" : basePath}${search}${hash}`;
  }

  return `${basePath}${search}${hash}`;
};

export const switchLanguageWithFade = async ({
  lng,
  i18n,
  location,
  navigate,
}) => {
  if (!lng || !i18n || !location || !navigate) return false;
  if (isLanguageTransitionInProgress || lng === i18n.language) return false;

  isLanguageTransitionInProgress = true;
  const targetPath = getLocalizedPath(location, lng);
  const scrollY = typeof window !== "undefined" ? window.scrollY || 0 : 0;

  if (typeof document !== "undefined") {
    document.body.classList.add("lang-fade");
  }

  try {
    await wait(LANGUAGE_FADE_OUT_MS);
    await ensureLanguageBundle(lng, i18n);
    await i18n.changeLanguage(lng);
    navigate(targetPath, { replace: true });
    await wait(LANGUAGE_FADE_IN_DELAY_MS);
    restoreScrollPosition(scrollY);
    return true;
  } finally {
    if (typeof document !== "undefined") {
      document.body.classList.remove("lang-fade");
      restoreScrollPosition(scrollY);
    }
    isLanguageTransitionInProgress = false;
  }
};
